import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Container, Title, Description, AccountButton } from './changePasswordSuccess.styles';
import messages from './changePasswordSuccess.messages';
import { ROUTES } from '../../../routes';

export const ChangePasswordSuccessBase = ({ intl, history }) => (
  <Container>
    <Title>
      <FormattedMessage {...messages.title} />
    </Title>
    <Description>
      <FormattedMessage {...messages.description} />
    </Description>
    <AccountButton onClick={() => history.push(ROUTES.account.base)} label={intl.formatMessage(messages.buttonLabel)} />
  </Container>
);

ChangePasswordSuccessBase.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export const ChangePasswordSuccess = injectIntl(ChangePasswordSuccessBase);
